import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { IconAlertCircle } from '@iwoca/icons';
import { AlertBox } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import styles from './NewOverdueView.module.css';

export const OverdueAlert = ({ overdueAmount }: { overdueAmount: number }) => {
    return (
        <AlertBox variant="failure" className={styles.alertBox}>
            <IconAlertCircle className={styles.icon} />
            <div className={styles.descriptionContainer}>
                <p className={styles.description}>
                    <FormattedMessage
                        id="_.new_overdue_dashboard.overdue_alert"
                        defaultMessage="<strong>Time to get back on track</strong> - you're overdue by <strong>{amount}</strong>"
                        values={{
                            strong: (chunks) => <strong>{chunks}</strong>,
                            amount: <FormattedCurrency value={overdueAmount} />
                        }}
                    />
                </p>
            </div>
        </AlertBox>
    );
};
